import React from "react";
import ReactDOM from "react-dom";
import Slider from "react-slick";
import parse from "html-react-parser";

const resizeSliderButtons = () => {
  setTimeout(() => {
    const arrows = document.querySelectorAll(".block--profiles .slick-arrow");
    const firstProfileImgHeight =
      document.querySelector(".profile__img")?.clientHeight;
    if (!firstProfileImgHeight) return;

    arrows.forEach((arrow) => {
      arrow.style.top = firstProfileImgHeight / 2 + "px";
    });
  }, 500);
};

const sliders = document.querySelectorAll("[data-slider]");

var settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
  ],
};

sliders.forEach((slider) => {
  const sliderInnerHtml = slider.innerHTML;

  ReactDOM.render(
    <Slider {...settings}>{parse(sliderInnerHtml)}</Slider>,
    slider
  );

  resizeSliderButtons();
});

window.addEventListener("resize", resizeSliderButtons);
